import { supabase } from '../supabaseClient';

export const PECUARIA_CHANGED = 'climorax:pecuaria-changed';
function describeError(error) {
  if (['PGRST202', '42P01', '42883'].includes(error?.code)) return new Error('Pecuária ainda não está disponível neste ambiente. Nenhum registro foi alterado.');
  if (['23514', '23502', '22003', '22P02'].includes(error?.code)) return new Error('Confira os campos: valores positivos, área útil e altura de entrada maior que a de saída.');
  return new Error(error?.message || 'Não foi possível conectar. Confira sua conexão e tente novamente.');
}
export async function loadPecuaria(propertyId = null) {
  const { data, error } = await supabase.rpc('pecuaria_painel', { p_propriedade: propertyId || null });
  if (error) throw describeError(error);
  if (![1, 2].includes(data?.version) || !['properties', 'plots', 'pastures', 'lots', 'occupations', 'measurements'].every(key => Array.isArray(data[key]))
    || (data.version === 2 && !Array.isArray(data.sales))) {
    throw new Error('Resposta de Pecuária incompleta. Atualize a consulta.');
  }
  return { ...data, sales: Array.isArray(data.sales) ? data.sales : [] };
}
export async function loadPecuariaEvents({ propertyId = null, plotId = null, before = null, offset = 0 } = {}) {
  const { data, error } = await supabase.rpc('pecuaria_caderno', { p_propriedade: propertyId || null, p_talhao: plotId || null, p_antes: before, p_offset: offset });
  if (error) throw describeError(error);
  if (!Array.isArray(data)) throw new Error('Histórico pecuário incompleto. Atualize a consulta.');
  return data;
}

export async function resolvePecuariaPhysicalPlot(propertyId, legacyPlotId) {
  if (!propertyId || legacyPlotId == null) throw new Error('Selecione a propriedade e o talhão para consultar o histórico.');
  // Parte do Caderno ainda usa IDs legados. Resolver apenas pelos vínculos
  // persistidos, nunca por nome/posição ou pelo primeiro talhão da propriedade.
  const { data, error } = await supabase.rpc('obter_estrutura_operacional_propriedades_usuario');
  if (error) throw describeError(error);
  const property = data?.propriedades?.find(p => String(p.id) === String(propertyId) && p.visivel !== false);
  const matches = (property?.talhoes || []).filter(plot => plot.talhoesLegados?.some(link => String(link.id) === String(legacyPlotId))
    || plot.plantios?.some(planting => String(planting.talhaoLegadoId) === String(legacyPlotId)));
  if (matches.length !== 1) throw new Error(matches.length ? 'Este vínculo físico precisa de revisão. O histórico não será associado por aproximação.' : 'Este talhão ainda não possui vínculo físico para registros pecuários.');
  return matches[0].id;
}
export async function registerPecuaria(propertyId, action, data, requestId) {
  if (!propertyId || !requestId) throw new Error('Selecione a propriedade e confirme o registro.');
  const result = await supabase.rpc('pecuaria_registrar', { p_propriedade: propertyId, p_acao: action, p_dados: data, p_chave: requestId });
  if (result.error) throw describeError(result.error);
  if (!result.data?.registrado) throw new Error('Registro não confirmado. Tente novamente sem alterar os campos.');
  window.dispatchEvent(new CustomEvent(PECUARIA_CHANGED, { detail: { propertyId } }));
  return result.data;
}

export async function registerPecuariaSale(propertyId, data, requestId) {
  if (!propertyId || !requestId) throw new Error('Selecione a propriedade e confirme a venda.');
  const result = await supabase.rpc('pecuaria_registrar_venda', { p_propriedade: propertyId, p_dados: data, p_chave: requestId });
  if (result.error) throw describeError(result.error);
  if (!result.data?.registrado) throw new Error('Venda não confirmada. Tente novamente sem alterar os campos.');
  window.dispatchEvent(new CustomEvent(PECUARIA_CHANGED, { detail: { propertyId } }));
  return result.data;
}
